import { useEffect, useState } from 'react';
import api from '@/lib/api';
import { getWhitelabelConfig } from '@/lib/whitelabel';
import useStoreSubdomain from '@/hooks/useStoreSubdomain';
import { useAuth } from '@/lib/auth';
import { applyStoreThemeVars, resolveStoreTheme } from '@/lib/storeTheme';

export default function useStoreBranding({ mode = 'public' } = {}) {
  const subdomain = useStoreSubdomain();
  const { user } = useAuth();
  const [theme, setTheme] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      try {
        if (mode === 'customer' && user?.tenant_id) {
          const res = await api.get('/customer/store-branding');
          if (!cancelled) setTheme(resolveStoreTheme(res.data));
          return;
        }

        if (!subdomain) {
          if (!cancelled) setTheme(null);
          return;
        }

        const res = await api.get(`/store/${subdomain}`);
        const wl = getWhitelabelConfig(res.data);
        if (!cancelled) {
          setTheme(resolveStoreTheme({
            ...res.data,
            branding: {
              brand_name: wl.brandName,
              logo_url: wl.logoUrl,
              favicon_url: wl.faviconUrl,
            },
          }));
        }
      } catch {
        if (!cancelled) setTheme(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => { cancelled = true; };
  }, [mode, subdomain, user?.tenant_id]);

  useEffect(() => {
    if (theme) applyStoreThemeVars(theme);
  }, [theme]);

  return { theme, loading };
}
